import { render, staticRenderFns } from "./Rede.vue?vue&type=template&id=06a82af4&"
import script from "./Rede.vue?vue&type=script&lang=js&"
export * from "./Rede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports